import React from "react"
import { Collapse } from "reactstrap";
import Icon from "storybookComponents/Icon"

const LeftMenu = ({ classes, allEmails, handleSubMenuCallback, group, selectedSubMenu }) => {
  const [menu, setMenu] = React.useState(group)
  const [subMenu, setSubMenu] = React.useState(selectedSubMenu);


  const handleMenuClick = (name) => {
    if (name == menu) {
      setMenu("");
    } else {
      setMenu(name);
    }
  }

  const handleSubmenuClick = (item) => {
    setSubMenu(item.email_id);
    handleSubMenuCallback(item)
  }

  const renderSubMenu = (child, index) => {
    return (
      <div
        onClick={() => handleSubmenuClick(child)}
        className={`${classes.menu} ${subMenu == child.email_id ? classes.subMenuSelected : classes.subMenu}`}
        key={index}>{child.emailName}</div>
    )
  }

  const renderMenu = (item, index) => {
    return (
      <div className={menu == item.name ? classes.selectedMenu : ''}>
        <div className={classes.menu} onClick={() => handleMenuClick(item.name)} key={index}>
          <span>{item.name}</span>
          <Icon type="icon-down-arrow" className={`${menu == item.name ? classes.iconRotate : ''}`} size="sm" />
        </div>
        <Collapse isOpen={menu == item.name}>
          {item.children.map(renderSubMenu)}
        </Collapse>
      </div>
    )
  }
  return (
    <div className={classes.menuContainer}>
      {allEmails.map(renderMenu)}
    </div>
  )
}

export default LeftMenu